export const css = {
	root: 'axDoGMzJ',
	close: '_1JlPWUzK',
	indicator: '_3XWaqeqF',
	tabButtons: '_2vA0L2Bl',
	tabButton: '_1vHC46SD',
	disabledTabButton: '_1icVYBuC',
	activeTabButton: 'E_QRSbTw',
	closeable: '_2KVsdQPm',
	tab: '_2EvW6XlA',
	alignLeft: '_1oXlrFMG',
	alignRight: '_2MUOMp_1',
	tabs: 'V5XsVd5C',
	alignBottom: '_1i6n4D0z',
	indicatorActive: '_1CZ8shWA',
	indicatorContent: '_1itFth5_',
	tabButtonContent: '_3mLN_bSa',
	' _key': 'afcpe-theme/afcpe/base-widgets/tab-container'
};

export default css;
